import { dataCountOption } from "#utils/seeds.js";
import { CustomButton } from "#components";
import React from "react";

export default function FilterBar({
  onChange,
  searchInput,
  onSearchButtonClick,
  onSearchChange,
  rowLimit,
}) {
  return (
    <div className="wrapper-card">
      <div className="row">
        <div className="col-xl-12">
          <form>
            <div className="row justify-content-between g-3">
              <div className="col-xl-6">
                <div className="filter-wrapper">
                  <div className="filter-date-blk">
                    <div class="form-block p-relative">
                      <input
                        type="text"
                        class="form-control"
                        id="search"
                        placeholder="Search"
                        value={searchInput}
                        onChange={onSearchChange}
                        onKeyPress={(e) =>
                          e.key === "Enter" && onSearchButtonClick
                        }
                      />
                      <span class="search-icon"></span>
                    </div>
                    <div className="filter-action-btn-blk">
                      <CustomButton
                        onClick={onSearchButtonClick}
                        title="Search"
                        className="btn primary-btn"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="filter-search-btn-blk">
                  <div className="form-block show_select d-flex justify-content-end align-items-center">
                    <label htmlFor="showenteries">Show</label>
                    <select
                      onChange={onChange}
                      value={rowLimit}
                      name
                      id="showenteries"
                      className="form-select"
                    >
                      {dataCountOption.map((data) => (
                        <option key={data.id}>{data.page}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
